import MarketingLayout from "@/components/MarketingLayout";
import { Users } from "lucide-react";

const TANISHKA_IMG = "/tanishka.jpg?v=5";
const AARYA_IMG = "/aarya.jpg";

const leadership = [
  { name: "Tanishka Padhye", role: "CEO & Co-Founder", color: "bg-[#FBE7C6]", image: TANISHKA_IMG },
  { name: "Aarya Gokhale", role: "CEO & Founder", color: "bg-[#D6E6FA]", image: AARYA_IMG },
];

const AVIZEH_IMG = "/avizeh.jpg";

const ARJUN_IMG = "/arjun.jpg";

const teamSections = [
  {
    title: "Marketing",
    color: "bg-[#FFAEBC]",
    members: [
      { name: "Avizeh Baig", role: "Marketing Lead", image: AVIZEH_IMG },
    ],
  },
  {
    title: "Finance",
    color: "bg-[#FBE7C6]",
    members: [
      { name: "Arjun Rao", role: "Finance Lead", image: ARJUN_IMG },
    ],
  },
];

const MeetTeamPage = () => {
  return (
    <MarketingLayout>
      {/* Hero */}
      <section className="py-20 sm:py-28 px-6 bg-gradient-to-b from-[#D6E6FA]/40 to-[#FDFBF7]">
        <div className="container mx-auto text-center max-w-3xl">
          <div className="inline-block bg-[#3C8DE4] text-white border-2 border-[#0A0A0A] rounded-full px-4 py-1 text-xs font-bold uppercase tracking-wider mb-6" data-testid="team-badge">
            Our Team
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6">
            Meet Our Team
          </h1>
          <p className="text-base sm:text-lg text-[#4A4A4A] leading-relaxed">
            The passionate volunteers and leaders behind Virtually Verbal.
          </p>
        </div>
      </section>

      {/* Leadership */}
      <section className="py-16 px-6" data-testid="leadership-section">
        <div className="container mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl font-bold mb-3">Leadership</h2>
          </div>
          <div className="grid sm:grid-cols-2 gap-6 max-w-lg mx-auto">
            {leadership.map((person) => (
              <div key={person.name} className="brutalist-card p-8 text-center" data-testid={`leader-${person.name.split(" ")[0].toLowerCase()}`}>
                <div className="w-28 h-28 rounded-full border-2 border-[#0A0A0A] overflow-hidden mx-auto p-1 bg-white">
                  <img src={person.image} alt={person.name} className="w-full h-full object-cover rounded-full" style={{ objectPosition: "center 20%" }} />
                </div>
                <h3 className="text-lg font-bold mt-4 mb-1">{person.name}</h3>
                <p className="text-sm text-[#3C8DE4] font-semibold">{person.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Sections */}
      <section className="py-16 px-6 bg-white border-y-2 border-[#0A0A0A]" data-testid="team-sections">
        <div className="container mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl font-bold mb-3">Our Departments</h2>
            <p className="text-sm text-[#4A4A4A]">Virtually Verbal is powered by dedicated student volunteers across these teams.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-6 max-w-5xl mx-auto">
            {teamSections.map((section) => (
              <div key={section.title} className={`brutalist-card p-6 ${section.color} w-full sm:w-64`} data-testid={`dept-${section.title.toLowerCase()}`}>
                <div className="w-10 h-10 rounded-full bg-white border-2 border-[#0A0A0A] flex items-center justify-center mb-4">
                  <Users className="w-5 h-5" />
                </div>
                <h3 className="text-base font-bold mb-3">{section.title}</h3>
                <div className="space-y-3">
                  {section.members.map((m, i) => (
                    <div key={i} className="text-sm text-center">
                      {m.image && (
                        <div className="w-20 h-20 rounded-full border-2 border-[#0A0A0A] overflow-hidden mx-auto mb-2 p-1 bg-white">
                          <img src={m.image} alt={m.name} className="w-full h-full object-cover rounded-full" style={{ objectPosition: "center 20%" }} />
                        </div>
                      )}
                      <span className="font-semibold">{m.name}</span>
                      <span className="text-[#4A4A4A] block text-xs">{m.role}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6">
        <div className="container mx-auto text-center max-w-xl">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Want to Join Our Team?</h2>
          <p className="text-sm text-[#4A4A4A] mb-6">
            We are always looking for passionate volunteers to help grow our global community.
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfPAYDoFjimw7ESCDdVcp8dXMN2PyRUSN_lVfJgcLzy-CpvOQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="brutalist-btn-primary inline-block"
            data-testid="join-team-cta"
          >
            Apply Now
          </a>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default MeetTeamPage;
